// src/pages/Userpanel/AdsDetail.jsx
import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";

const AdsDetail = () => {
  const navigate = useNavigate();
  const { adId } = useParams();
  const adNumber = Number(adId);

  const [user, setUser] = useState(null);
  const [files, setFiles] = useState([null, null]); // শুধু ২টা
  const [loading, setLoading] = useState(true);
  const [completed, setCompleted] = useState(false);
  const [timeLeft, setTimeLeft] = useState(0); // Countdown for midnight

  // TikTok লিংক (সবগুলো একই লিংক)
  const tiktokVideoLink = "https://www.tiktok.com/";

  // ✅ Fetch user & check ad access
  useEffect(() => {
    const fetchUser = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          navigate("/mytask", { replace: true });
          return;
        }

        const resUser = await axios.get("https://api.earnmoney0.top/api/user/me", {
          headers: { Authorization: `Bearer ${token}` },
        });

        setUser(resUser.data);

        const resCheck = await axios.get(
          `https://api.earnmoney0.top/api/user/check-ad/${adNumber}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );

        if (!resCheck.data.allowed) {
          navigate("/mytask", { replace: true });
          return;
        }

        if (resUser.data.adsCompleted.includes(adNumber)) {
          const now = new Date();
          const todayMidnight = new Date(now.getFullYear(), now.getMonth(), now.getDate()).getTime();
          const lastCompleteTime = new Date(resUser.data.adsCompletedTimes?.[adNumber] || 0).getTime();

          setCompleted(lastCompleteTime >= todayMidnight);
        }
      } catch (err) {
        navigate("/mytask", { replace: true });
      } finally {
        setLoading(false);
      }
    };

    if (!isNaN(adNumber)) fetchUser();
    else navigate("/mytask", { replace: true });
  }, [adNumber, navigate]);

  // ✅ Countdown for midnight reset
  useEffect(() => {
    if (!completed) return;

    const interval = setInterval(() => {
      const now = new Date().getTime();
      const midnight = new Date();
      midnight.setHours(0, 0, 0, 0);
      midnight.setDate(midnight.getDate() + 1);
      const diff = midnight.getTime() - now;

      setTimeLeft(diff > 0 ? diff : 0);

      if (diff <= 0) {
        setCompleted(false);
        clearInterval(interval);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [completed]);

  // ✅ Handle file upload
  const handleFileChange = (e, index) => {
    const newFiles = [...files];
    newFiles[index] = e.target.files[0];
    setFiles(newFiles);
  };

  // ✅ Open TikTok link in new tab
  const handleClick = () => {
    window.open(tiktokVideoLink, "_blank");
  };

  // ✅ Complete task with backend
  const handleComplete = async () => {
    if (files.some((f) => f === null)) {
      return alert("দয়া করে 2 টি কাজের প্রমান আপলোড করুন🚫");
    }

    try {
      const token = localStorage.getItem("token");

      const res = await axios.post(
        "https://api.earnmoney0.top/api/user/complete-ad",
        { adId: adNumber },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      if (!res.data.success) {
        alert(res.data.message || "Failed to complete task");
        return navigate("/mytask", { replace: true });
      }

      setCompleted(true);
      setUser((prev) => ({
        ...prev,
        mainBalance: res.data.mainBalance,
        adsCompleted: [...(prev.adsCompleted || []), adNumber],
        adsCompletedTimes: {
          ...(prev.adsCompletedTimes || {}),
          [adNumber]: new Date().toISOString(),
        },
      }));

      alert(`Task Completed ✅ +৳10 added to Main Balance`);
      navigate("/mytask", { replace: true });
    } catch (err) {
      console.error(err);
      navigate("/mytask", { replace: true });
    }
  };

  // ✅ Format countdown
  const formatTime = (ms) => {
    const totalSeconds = Math.floor(ms / 1000);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
    return `${hours.toString().padStart(2, "0")}:${minutes
      .toString()
      .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
  };

  const adTasks = [
    { type: "ভিডিও এটি অপেন করুন" },
    { type: "ভিডিও এটিও অপেন করুন" },
  ];

  if (loading) {
    return <div style={{ padding: 20 }}>Loading Task...</div>;
  }

  return (
    <div style={styles.page}>
      <h2 style={styles.headline}>
        আজকের কাজ নিছের এগুলো পুরন করে স্ক্রিনশট জমা করুন 💯
      </h2>

      {/* ✅ Task Buttons */}
      <div style={styles.tasks}>
        {adTasks.map((task, i) => (
          <button
            key={i}
            onClick={handleClick}
            style={{ ...styles.link, backgroundColor: colors[i % colors.length] }}
          >
            {task.type} 🔗
          </button>
        ))}
      </div>

      {/* ✅ File Upload Section */}
      <div style={styles.uploadSection}>
        <p>
          সব গুলা ভিডিও ১ মিনিট করে দেখবেন, তারপর স্ক্রিনশট উঠিশে এখানে আপলোড করে Complete Task এ চাপ দিবেন ✅
        </p>
        {files.map((file, i) => (
          <div key={i} style={styles.fileWrapper}>
            <input
              type="file"
              onChange={(e) => handleFileChange(e, i)}
              style={styles.fileInput}
              disabled={completed}
            />
            {file && <span style={styles.fileName}>{file.name}</span>}
          </div>
        ))}
      </div>

      {/* ✅ Complete Button */}
      <button
        style={{
          ...styles.btn,
          backgroundColor: completed ? "#16a34a" : "#0ea5e9",
          cursor: completed ? "not-allowed" : "pointer",
        }}
        onClick={handleComplete}
        disabled={completed}
      >
        {completed ? "✅ Completed" : "Complete Task"}
      </button>

      {/* ✅ Countdown Timer */}
      {completed && timeLeft > 0 && (
        <div style={{ marginTop: 8, color: "#f59e0b", fontWeight: 600 }}>
          Unlock in: {formatTime(timeLeft)}
        </div>
      )}
    </div>
  );
};

export default AdsDetail;

// ---------- STYLES ----------
const colors = ["#f97316", "#eab308", "#3b82f6", "#10b981", "#8b5cf6"];

const styles = {
  page: {
    minHeight: "100vh",
    background: "#f0f4f8",
    padding: "20px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  headline: {
    textAlign: "center",
    marginBottom: 20,
    fontSize: 22,
    color: "#7a0f7a",
    fontWeight: 700,
  },
  tasks: {
    display: "flex",
    flexDirection: "column",
    gap: 12,
    width: "100%",
    maxWidth: 500,
    marginBottom: 25,
  },
  link: {
    padding: "12px 16px",
    borderRadius: 10,
    color: "#fff",
    fontWeight: 600,
    textDecoration: "none",
    textAlign: "center",
    boxShadow: "0 3px 6px rgba(0,0,0,0.1)",
    transition: "0.3s",
  },
  uploadSection: {
    width: "100%",
    maxWidth: 500,
    display: "flex",
    flexDirection: "column",
    gap: 10,
    marginBottom: 20,
  },
  fileWrapper: { display: "flex", alignItems: "center", gap: 10 },
  fileInput: {
    padding: 10,
    borderRadius: 8,
    border: "1px solid #ccc",
    fontSize: 14,
    width: "100%",
  },
  fileName: { fontSize: 14, color: "#0f172a", fontWeight: 500 },
  btn: {
    width: "100%",
    maxWidth: 500,
    padding: 14,
    borderRadius: 8,
    border: "none",
    fontWeight: 600,
    color: "#fff",
    fontSize: 16,
  },
};